import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: "100%",
    height: "300px",
    fontFamily: "Montserrat",
  },

  rootLegend: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    overflowX: "scroll",
    overflowY: "hidden",
  },

  textLegend: {
    marginRight: "10px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    textOverflow: "clip",
    whiteSpace: "nowrap",
  },
}));
